export default interface IMedMUser {
    Id: string;
    UserId: string;
    MedicalRecordId: string;
    Email: string;
    Password: string;
    FirstName: string;
    LastName: string;
    MemberId: string;
    IsAccountCreated: boolean;
}

export class MedMUser implements IMedMUser {
    Id: string;
    UserId: string;
    MedicalRecordId: string;
    Email: string;
    Password: string;
    FirstName: string;
    LastName: string;
    MemberId: string;
    IsAccountCreated: boolean;
    constructor() {
        this.Id = null;
        this.UserId = '';
        this.MedicalRecordId = '';
        this.Email = '';
        this.Password = '';
        this.FirstName = '';
        this.LastName = '';
        this.MemberId = '';
        this.IsAccountCreated = false;
    }
}
